class RebuyProductCard extends HTMLElement {
  constructor() {
    super()
  }

  initSlider () {
  }

  connectedCallback() {
    this.waitVisible()
  }

  disconnectedCallback() {
  }

  waitVisible() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.getProductData()
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  getProductData() {
    fetch(this.productCardUrl)
      .then((response) => response.text())
      .then((text) => {
        this.innerHTML = text;
        this.querySelectorAll('image-element').forEach(element => {
          element.classList.add('aos-init')
          element.classList.add('aos-animate')
        })
        this.addQuickShopHandle();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  addQuickShopHandle() {
    this.querySelectorAll('.quick-product__btn').forEach(button => {
      button.classList.remove('quick-product__btn--not-ready')
      const innerElement = button.closest('.grid-product')
      var productId = innerElement.dataset.productId
      var handle = innerElement.dataset.productHandle
      theme.preloadProductModal(handle, productId, button)
    })
  }

  get productUrl () {
    return this.getAttribute('url')
  }

  get productCardUrl () {
    return this.productUrl + '?view=product-card'
  }
}

customElements.define('rebuy-product-card', RebuyProductCard)
